import React from 'react';
import { func, instanceOf } from 'prop-types';
import DEBreadcrumb from '../../shared/DEBreadcrumb';
import ImportActions from '../../shared/ImportActions';

const TargetMainHeader = ({ setView, definition }) => {
  const showImportActions = !definition.loading && definition.data.length === 0 && !definition.hasDefinition;
  return (
    <div className="de--header" data-test="target-main-header">
      <div className="de--header-title">
        <h2>Available Targets</h2>
      </div>
      {!showImportActions && definition.hasDefinition && <ImportActions setView={setView} />}
      <DEBreadcrumb
        parent="DataHub / "
        child="Activate Campaign Targets"
      />
    </div>
  );
};

TargetMainHeader.propTypes = {
  setView: func,
  definition: instanceOf(Object),
};

export default TargetMainHeader;
